import { useRef } from "react";
import { ClockIcon, DocumentIcon, Signer } from "assets/icons";
import Chip from "components/chip/chip";
import Divider from "components/divider/divider";
import useModal from "components/modal/useModal";
import { getInterimPdfUrl } from "helper/interimPdfUrl";
import {
  getContractAvenantNumber,
  getContractFileName,
} from "helper/contractFileName";
import { dateWordShort } from "helper/helper";
import { fetchSignatureLink } from "helper/signatureLink";
import UseContext from "hooks/useContext";

const Cardcontract = ({ champsBody, isWaiting, filterStatus }) => {
  const { toggle } = useModal();
  const isFetchingSignatureLink = useRef(false);
  const rUser = localStorage.getItem("rUser");
  const { setSignatureLink, setDataYousign } = UseContext();
  const colorContract = {
    0: "ALERT",
    1: "INFO",
  };
  const contentContract = {
    0: "À signer",
    1: "Signé",
  };
  const handleSign = (e, contract, item, missionObjectId) => {
    e.preventDefault();
    if (isFetchingSignatureLink.current) return;
    isFetchingSignatureLink.current = true;

    setDataYousign({
      yousign_id: contract.yousign_id,
      contract_id: contract._id,
      mission_id: item,
      filename: contract.fileName,
      filepath: contract.filePath,
    });
    setSignatureLink("");
    toggle("doc_c_signature");
    fetchSignatureLink({ idMission: missionObjectId, contract })
      .then(setSignatureLink)
      .finally(() => {
        isFetchingSignatureLink.current = false;
      });
  };

  // One card per document, as the desktop table has one row per document: a
  // mission carries its contract and its amendments, and a tab only shows the
  // ones in its own state. A document waiting to be sent carries no state at
  // all — it used to draw an empty chip on top of the others.
  const documents = (champsBody?.contract_tempworker || []).filter(
    (contract) => !filterStatus || contract.status === filterStatus
  );
  return (
    <>
      {isWaiting ? (
        <>
          <div
            className={
              "flex flex-col gap-4 px-4 py-5 animate-fadeIn animate-pulse"
            }
          >
            <p className={"h-2 bg-gray-200 rounded w-2/4"}></p>
            <div className={"h-2 bg-gray-200 rounded w-1/4"}></div>
            <div className={"h-2 bg-gray-200 rounded w-3/4"}></div>
          </div>
          <Divider w={100} />
        </>
      ) : champsBody?.contract_pending ? (
        <>
          <div
            className={
              "flex justify-between items-center h-28 px-4 py-5 animate-fadeIn"
            }
          >
            <div className={"flex flex-col gap-2 min-w-0"}>
              <div className={"ft-b text-gray-900 font-medium"}>
                {champsBody.title}
              </div>
              <div className={"flex items-center"}>
                {champsBody.companyCollection?.[0]?.name_commercial || ""}
              </div>
            </div>
            <div
              className={
                "ml-auto shrink-0 flex items-center gap-2 ft-sm text-gray-500 whitespace-nowrap"
              }
            >
              <ClockIcon wh={24} color={"#6B7280"} />
              Bientôt disponible
            </div>
          </div>
          <Divider w={100} />
        </>
      ) : (
        documents.map((contract, index) => {
          const avenantNumber = getContractAvenantNumber(contract);

          return (
            <div key={contract._id || index}>
              <div
                className={
                  "flex justify-between gap-3 px-4 py-5 animate-fadeIn"
                }
              >
                <div className={"flex flex-col gap-2"}>
                  <div className={"ft-b text-gray-900 font-medium"}>
                    {avenantNumber > 0
                      ? `Avenant n°${avenantNumber} · contrat N° ${contract.id_bestt}`
                      : `Contrat N° ${contract.id_bestt}`}
                  </div>
                  <div>
                    <Chip
                      type={"INDICATOR"}
                      color={colorContract[contract.status]}
                    >
                      {contentContract[contract.status]}
                    </Chip>
                  </div>
                  <div className={"flex items-center"}>
                    {champsBody.companyCollection?.[0]?.name_commercial || ""} .{" "}
                    {dateWordShort(contract.createdAt || champsBody.createdAt)}
                  </div>
                </div>

                <div className={"m-3 flex items-center justify-center"}>
                  {contract.status === "0" && rUser !== "200" ? (
                    <span
                      onClick={(e) => {
                        handleSign(
                          e,
                          contract,
                          champsBody.id_mission,
                          champsBody._id
                        );
                      }}
                    >
                      <Signer wh={24} />
                    </span>
                  ) : (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={getInterimPdfUrl({
                        type: "contract",
                        fileName: getContractFileName(
                          champsBody.id_mission,
                          contract
                        ),
                      })}
                    >
                      <DocumentIcon wh={35} color={"#111827"} />
                    </a>
                  )}
                </div>
              </div>
              <Divider w={100} />
            </div>
          );
        })
      )}
    </>
  );
};

export default Cardcontract;
